import { makeAutoObservable } from 'mobx'

export default class StandStore {
  name: string = ''

  constructor() {
    makeAutoObservable(this)
  }

  setName = (data: string): string => {
    this.name = data

    return this.name
  }
}
